import {
  IonButton,
  IonCol,
  IonGrid,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
} from "@ionic/react";
import React from "react";
import "./PlayerModalPopup.scss";

interface PlayerModalPopupProps {
  showModal: boolean;
  url: string;
  type: any;
  onCancel: () => void;
  onOk: () => void;
}

const PlayerModalPopup: React.FC<PlayerModalPopupProps> = (props) => {
  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="select-provider-modal"
    >
      <IonItem>
        <IonLabel className="provider-label">Player</IonLabel>
      </IonItem>
      <IonGrid className="scrollbar">
        <IonRow>
          <IonCol>
            {props.type === 3 && (
              <video controls className="video-wrapper">
                <source src={props.url}></source>
                Your browser does not support the video tag.
              </video>
            )}

            {props.type === 2 && (
              <audio controls>
                <source src={props.url}></source>
                Your browser does not support the video tag.
              </audio>
            )}
          </IonCol>
        </IonRow>
      </IonGrid>
      <div className="buttons-container-div">
        <IonItem lines="none">
          <IonButton
            slot="end"
            className="submit-btn button primary-btn btn-curved"
            onClick={() => {
              props.onOk();
            }}
          >
            Ok
          </IonButton>
        </IonItem>
      </div>
    </IonModal>
  );
};

export default PlayerModalPopup;
